@if (isCheckedIn()) {
  <span class="badge rounded-1 text-bg-success"
        i18n><ng-content select="[checkin]"></ng-content></span>
} @else {
  <span class="badge rounded-1 text-bg-danger"
        i18n><ng-content select="[checkout]"></ng-content></span>
}